import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  getLoggedUser() {
    const storage = localStorage.getItem('ud');
    let userInSession = '';
    if (storage) {
      const decode = atob(storage);
      userInSession = JSON.parse(decode);
    }

    if (userInSession) {
      return userInSession;
    }
  }
  getLoggedCompany() {
    const storage = localStorage.getItem('empresa');
    let companyInSession = '';
    if (storage) {
      const decode = atob(storage);
      companyInSession = JSON.parse(decode);
    }

    if (companyInSession) {
      return companyInSession;
    }
  }
  getAt() {
    const storage = localStorage.getItem('at');
    let atInSession = '';
    if (storage) {
      const decode = atob(storage);
      atInSession = JSON.parse(decode);
    }

    if (atInSession) {
      return atInSession;
    }
  }

  parseNumberToPesos(digit: number): string {
    if (digit) {
      return '$' + digit.toLocaleString();
    }
  }
}
